import React from 'react';

import { Card, CardMedia, Typography, CardActions } from '@mui/material';

type Props = {
  image: string;
  name?: string;
};

export const PetCard: React.FC<Props> = ({ image, name }) => {
  return (
    <Card
      sx={{ minWidth: 160, maxWidth: 200, maxHeight: 160, borderRadius: 2 }}
    >
      <CardMedia
        component="img"
        height="160"
        width="160"
        image={image}
        alt="imagem do pet"
      />

      {name && (
        <CardActions>
          <Typography fontWeight="500">{name}</Typography>
        </CardActions>
      )}
    </Card>
  );
};

